import React, { createContext, useState } from 'react'

export const FromContext = createContext(null)

export const FromProvider = ({ children }) => {
  const [from, setFrom] = useState(null)

  return (
    <FromContext.Provider
      value={{ from, setFrom }}
    >
      {children}
    </FromContext.Provider>
  )
}
